import React from 'react'
import {Flex} from '@components'
import {Button, Col, Form, Icon, Input, message, Row, Select, Spin, Upload} from 'antd'
import SiderMenu from '@pages/Assembly/siderMenu'
import Breadcrumb from '@pages/Assembly/Breadcrumb'
import TitleTop from '@pages/Assembly/titleTop'
import {createUuid, getLoginUser} from '@utils/NHCore'
import NHFetch from '@utils/NHFetch'

import CommonTip from '@pages/SelfHelp/common'
import NextButton from '@pages/SelfHelp/common/nextIndex'
import {mkbz} from '@pages/Assembly/siderMenu/menuObj'
import Hint from '@pages/SelfHelp/common/hint'
import View from "@pages/SelfHelp/isFeePay/view";
import NHFormItem from "@components/common/NHFormItem";

const Dragger = Upload.Dragger;
const FormItem = Form.Item;
const basicUrl = "/jxcm/sfjf";
const formItemLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
};
@Form.create()
export default class FeePayIndex extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            mkbz: 'GD053',
            hjmc: '',
            editable: true,
            update: false,
            loading: false,
            nextUrl: '',
            search: '',
            operable: true, // 是否显示环节
            nonOperationalData: {}, // 不可操作的数据

            isHide: true,
            fileList: [],
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'],   //可以导入的图片格式
            judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'],  //可以导入的非图片格式
            initPo:{},
            initFjPOs:[],
            uploading:false,
        }
    }

    componentDidMount() {
        this.queryQztjAndYlhj(operable => {
            if (operable) {
                this.getStuPayStatusInfo();
            }
        })
    }

    //查询前置条件和依赖环节
    queryQztjAndYlhj = callback => {
        let xsid = getLoginUser() ? getLoginUser().userId : ''
        if (!xsid) {
            this.setState({
                nonOperationalData: {nologin: true},
                operable: false
            })
            return
        }
        let zzbdhjid = this.getQueryString('pkid')
        NHFetch('/zzbd/queryQztjAndYlhj', 'GET', {xsid: xsid, zzbdhjid: zzbdhjid}).then(res => {
            if (res && res.data) {
                let kfsj = res.data['kfsj']
                let ylhj = res.data['ylhj']
                let qzhj = res.data['qzhj']
                let nohj = res.data['nohj']
                this.setState({nonOperationalData: res.data})
                if (kfsj && kfsj['YXSJ'] != '1') {
                    this.setState({operable: false})
                }

                if (ylhj && ylhj.length > 0) {
                    this.setState({operable: false})
                }

                if (qzhj && qzhj.length > 0) {
                    this.setState({operable: false})
                }

                if (nohj) {
                    this.setState({operable: false})
                }

                if (callback) {
                    callback(this.state.operable)
                }
            }
        })
    }

    getQueryString = name => {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }

    setMenuList = menuList => {
        let nextCount = 0
        let bz = this.state.mkbz
        menuList.map((elem, index) => {
            if (elem.HJDM == bz) {
                let hjmc = elem.HJMC
                this.setState({hjmc: hjmc})
                nextCount = index + 1
                return
            }
        })
        let menu = menuList[nextCount]
        if (menu) {
            let hjdm = menu.HJDM
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm]
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = '/customLink'
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                })
            }
        } else {
            this.setState({
                nextUrl: '',
                search: ''
            })
        }
    }

    //重新加载菜单
    reloadMenu = () => {
        this.refs.siderMenu.reloadMenuList()
    }


    getStuPayStatusInfo =()=>{
        NHFetch(basicUrl + "/getStuPayStatusInfo", "GET")
            .then(res => {
                if (res && res.code === 200) {
                    if (res.data) {
                        this.setState({initPo: res.data,isHide: res.data.axfjfqk === '1'});
                        // this.props.form.setFieldsValue({sfjf: res.data.sfjf});
                        let fileList = [];
                        if(res.data.sfjffjPOs){
                            res.data.sfjffjPOs.map((elem,index)=>{
                                //格式化对于附件取值
                                let file = {
                                    uid: elem.fjid,
                                    name: elem.fjmc,
                                    response:{
                                        data:{
                                            ssbh:elem.fjid,
                                            fjmc:elem.fjmc,
                                        }
                                    },
                                    status: 'done'
                                }
                                fileList.push(file);
                            })

                            this.setState({fileList:fileList});
                            this.props.form.setFieldsValue({sfjffj:{fileList:this.state.fileList}});
                        } else {
                            this.setState({fileList:[]});
                        }
                    }
                } else{
                    this.setState({initPo:{}});
                    this.setState({fileList:[]});
                    this.props.form.resetFields();
                }
            });
    }

    // 提交
    handleSubmit = e => {
        this.setState({loading:true});
        e.preventDefault();
        let zzbdhjid = this.getQueryString('pkid');
        this.props.form.validateFieldsAndScroll((err, values) => {
            if(err){
                this.setState({loading:false});
                return false;
            }
            console.log(values);
            const sfjf = values['sfjf'];

            if (sfjf === '1'){
                this.save(values);
            } else {
                const fj = values['sfjffj'];
                let isEmpty = false;
                if(fj){
                    if(fj['fileList'] && fj['fileList'].length>0){
                        isEmpty = false;
                    }else{
                        isEmpty = true;
                    }
                }else{
                    isEmpty = true;
                }

                if(sfjf === '0' && isEmpty){
                    this.props.form.setFields({
                        fj:{
                            value:undefined,
                                errors:[new Error('请上传材料证明')],
                        }
                    });
                    this.setState({loading:false});
                    return false;
                }

                let size = fj['fileList'].length;
                let file = fj['fileList'].filter((file) => {
                    if (file.status==='error') {
                        return false;
                    }
                    return true;
                });
                if(file.length!=size){
                    this.props.form.setFields({
                        fj:{
                            value:fj,
                            errors:[new Error('材料上传出错，请重新上传.')],
                        }
                    });
                    this.setState({loading:false});
                    return false;
                }

                let fileList = fj['fileList'];
                let fjlist = [];
                for(let i=0;i<fileList.length;i++){
                    let fjid = fileList[i].response.data.ssbh;
                    let fjmc = fileList[i].name;
                    fjlist.push({
                        fjid:fjid,
                        fjmc:fjmc
                    });
                }

                values['sfjffjPOList'] = fjlist;
                this.save(values);
            }
        });
    };

    save =(values) =>{
        NHFetch('/jxcm/sfjf/save',"POST",values)
            .then(res => {
                if (res && res.code === 200) {
                    message.success("学生是否缴费信息保存成功");
                    if (values['sfjf']==='1'){
                        this.commonSaveLinkTransactionStatus();
                    } else {
                        this.getStuPayStatusInfo();
                        this.reloadMenu();
                    }
                } else {
                    message.success("学生是否缴费信息保存失败");
                }
                this.setState({ loading: false })
            }).catch((res) => {
            this.setState({ loading: false })
            return res;
        });
    }

    //自动办理缴费环节
    commonSaveLinkTransactionStatus = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : "";
        let zzbdhjid = this.getQueryString("pkid");
        let params = { xsid: xsid, zzbdhjid: zzbdhjid };
        NHFetch("/zzbdCommon/commonSaveLinkTransactionStatus", "POST", params).then(
            res => {
                if (res) {
                    if (res.data === 1) {
                        this.getStuPayStatusInfo();
                        this.reloadMenu();
                    }
                } else {
                    message.error("自动办理学生是否缴费环节失败，请稍后重试！");
                }
            }
        );
    };

    showPreview=(url)=>{
        this.setState({
            previewImage:url,
            previewVisible: true
        });
    }

    //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常
    setJudge = (name, map) => {
        let flag = false;
        map.map(item => {
            if (name.indexOf(item) !== -1) {
                flag = true;
            }
        })
        return flag;
    }


    // 点击文件链接或预览图标时的回调
    handlePreview = file => {
        const isImage = /^image\/.*$/i.test(file.type);
        if (isImage) {
            if (file) {
                this.getBase64(file, imageUrl => {
                    this.setState({
                        previewImage: imageUrl,
                        previewVisible: true
                    });
                });
            } else {
                this.setState({
                    previewImage: file.url || file.thumbUrl,
                    previewVisible: true
                });
            }
        }else if(file && file['response'] && file['response']['data']){//其他情况
            let isImage = true;
            let fjmc = file['response']['data']['fjmc'];
            let ssbh = file['response']['data']['ssbh'];
            if (
                !this.setJudge(fjmc,this.state.judgeImgList)
            ) {
                isImage = false;
            }

            if (isImage) {
                this.showPreview(`anonymity/docrepo/download/file?attachmentId=${ssbh}`);
            } else {
                window.open(`anonymity/docrepo/download/file?attachmentId=${ssbh}`);
            }
        }
    };

    handleChange = ({ fileList } ) => {
        let count = 0;
        fileList.map((elem)=>{
            if(elem && elem['status'] && elem['status']==='uploading'){
                this.setState({uploading:true});
                return;
            }else if(elem && elem['status']){
                count++;
            }
        })
        if(count>0){
            this.setState({uploading:false});
        }
    }

    beforeUpload = (file) => {
        if (
            !(this.setJudge(file.name, this.state.judgeImgList) ||
                this.setJudge(file.name, this.state.judgeFileList))
        ) {
            message.error('不能上传该格式文件');
            return false;
        } else {
            return true;
        }
    }

    remove=(ssbh)=>{
        let url = `api/docrepo/attachment/sourceId/delete?souerceId=${ssbh}`;
        NHFetch(url,"POST").then(res => {
            if (res.data && res.data > 0) {
                message.success('已删除材料.');
            }
        });
    }

    render() {
        const {form} = this.props;
        const {getFieldDecorator} = this.props.form;
        const {initPo,isHide} = this.state;
        const props = {
            name: 'file',
            action: 'zuul/docrepo/upload',
            data: { uuid: createUuid(), type: '1' },

            onRemove: file => {
                this.setState(({ fileList }) => {
                    const index = fileList.indexOf(file);
                    const newFileList = fileList.slice();
                    newFileList.splice(index, 1);
                    this.props.form.setFieldsValue({sfjffj:{fileList:newFileList}});
                    return {
                        fileList: newFileList
                    };
                },()=>{
                    if(file.response && file.response.data && file.response.data.ssbh){
                        this.remove(file.response.data.ssbh);
                    }
                });
            },
            beforeUpload: file => {
                if(!this.beforeUpload(file)){
                    return false;
                }
                this.setState(({ fileList }) => ({
                    fileList: [...fileList, file]
                }));
                return true;
            },
            onChange:file=>{this.handleChange(file)},
            onPreview: this.handlePreview,
            fileList:this.state.fileList,
        };

        console.log("initPo: " ,initPo)

        let edit = false;
        if(initPo.shzt === null || initPo.shzt ==='2'){
            edit = true;
        }
        return (
            <div style={{position: 'relative'}}>
                {this.state.operable ? (
                <div>
                    <Flex className="w1180 mt-20" align="start">
                        <SiderMenu ref={'siderMenu'} setMenuList={this.setMenuList} title="自助报到"
                               mkbz={this.state.mkbz} menuType="自助报到"/>
                        <Flex.Item className="page_con_r" styleName="">
                            <Breadcrumb noLine list={[{name: '首页', url: '/index'}, {name: '自助报到', url: '/register'}, {name: this.state.hjmc}]}/>
                            <div className="box">
                                <Hint/>
                                {edit?
                                <Form onSubmit={this.handleSubmit}>
                                    <TitleTop title="学生是否缴费" extra={false}/>
                                    <div className="p-sw">
                                        <div style={{display:'none'}}>
                                            <NHFormItem id={'pkid'} initialValue={initPo.pkid} form={form}>
                                                <Input/>
                                            </NHFormItem>
                                        </div>
                                        <Flex align="start" wrap="wrap">
                                            <div className="form_item">
                                                <FormItem
                                                    {...formItemLayout}
                                                    label="是否缴费"
                                                >
                                                {getFieldDecorator('sfjf', {
                                                    initialValue: initPo.axfjfqk
                                                })(
                                                    <span>{initPo.axfjfqk === '1' ? '是' : '否'}</span>
                                                )}
                                                </FormItem>
                                            </div>
                                            {!isHide &&
                                                <div className="form_item" style={{marginLeft: '7%'}}>
                                                    <FormItem
                                                        labelCol= { {span: 8} }
                                                        wrapperCol={ {span: 16} }
                                                        label="贷款相关附件"
                                                    >
                                                        {getFieldDecorator('sfjffj', {
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message:
                                                                        '请上传材料证明'
                                                                }
                                                            ],
                                                        })(
                                                            <Dragger {...props}>
                                                                <p className="ant-upload-drag-icon">
                                                                    <Icon type="inbox" />
                                                                </p>
                                                                <Spin spinning={this.state.uploading}/>
                                                                <p className="ant-upload-text font-14">
                                                                    点击此处或拖拽文件到此
                                                                </p>
                                                            </Dragger>
                                                        )}
                                                    </FormItem>
                                                </div>
                                            }
                                            {initPo.shzt === '2' &&
                                                <div className="form_item" style={{marginLeft: '7%'}}>
                                                    <TitleTop title="申请审核" extra={false}/>
                                                    <div className="p-sw">
                                                        <div className="form_item" style={{width: '100%', marginBottom: '24px'}}>
                                                            <Row gutter={24}>
                                                                <Col span={5} style={{textAlign: 'right', paddingRight: 0}}><span
                                                                    style={{color: 'rgba(0, 0, 0, 0.85)'}}>审核意见&nbsp;: </span></Col>
                                                                <Col span={18}><span>{initPo.shyj}</span></Col>
                                                            </Row>
                                                        </div>
                                                        <br/>
                                                        <div className="form_item" style={{width: '100%', marginBottom: '24px'}}>
                                                            <Row gutter={24}>
                                                                <Col span={5} style={{textAlign: 'right', paddingRight: 0}}><span
                                                                    style={{color: 'rgba(0, 0, 0, 0.85)'}}>审核状态&nbsp;: </span></Col>
                                                                <Col span={18}><span style={{color: '#0066FF'}}>{initPo.shztmc}</span></Col>
                                                            </Row>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </Flex>

                                        <div className="text-center mt-50">
                                            <Button
                                                type="primary"
                                                htmlType="submit"
                                            >保存
                                            </Button>
                                            <NextButton nextUrl={this.state.nextUrl} search={this.state.search}/>
                                        </div>
                                    </div>
                                </Form>
                                    :
                                    <View reloadMenu={this.reloadMenu}
                                          nextUrl={this.state.nextUrl}
                                          getStuPayStatusInfo={this.getStuPayStatusInfo}
                                          search={this.state.search}
                                          showPreview={this.showPreview}
                                          setJudge={this.setJudge}
                                          data={this.state.initPo}
                                          judgeImgList={this.state.judgeImgList}/>}
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Spin style={{position: 'absolute', top: '300px', left: '60%'}}
                          spinning={this.state.loading}/>{' '}
                </div>
                    ) :
                    <CommonTip hjmc={'是否缴费'} key={'GD053'} mkbz="GD053" nonOperationalData={this.state.nonOperationalData}/>
                }
        </div>
        )
    }
}
